export default __webpack_public_path__ + "dd23d13422cf9bae503afb490114a5da.svg";